import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import remove from 'lodash/remove';

import PageSection from '~/src/features/domru-tv/packages/components/PageSection';
import { TSubscriptions, useSectionData } from '~/src/features/domru-tv/packages/hooks/useSectionData';

import SubscriptionsLayout from '../SubscriptionsLayout';

import * as ST from './styled';

interface IProps {
    isHideActive: boolean,
    setIsHideActive: Dispatch<SetStateAction<boolean>>,
    setConnectedItemsQuantity: Dispatch<SetStateAction<number>>,
}

const SubscriptionsDetails = ({ isHideActive, setIsHideActive, setConnectedItemsQuantity }: IProps): JSX.Element => {
    const { sectionWidgets = [] } = useSectionData<TSubscriptions>('subscriptions', true);

    const { connectedItemsQuantity, currentItems } = useMemo(() => {
        const unconnectedItems = [...sectionWidgets];
        const connectedItems = remove(unconnectedItems, widget => widget.activeVas);

        return {
            connectedItemsQuantity: connectedItems.length,
            currentItems: isHideActive ? unconnectedItems : sectionWidgets,
        };
    }, [isHideActive, sectionWidgets]);

    useEffect(() => {
        setConnectedItemsQuantity(connectedItemsQuantity);
    }, [connectedItemsQuantity, setConnectedItemsQuantity]);

    useEffect(() => {
        if (connectedItemsQuantity === sectionWidgets?.length) {
            setIsHideActive(false);
        }
    }, [connectedItemsQuantity, setIsHideActive, sectionWidgets?.length]);

    return (
        <ST.LayoutSection>
            <PageSection.Content>
                <SubscriptionsLayout subscriptions={currentItems}/>
            </PageSection.Content>
        </ST.LayoutSection>
    );
};

export default SubscriptionsDetails;
